(() => {
    class CollectionSlider extends HTMLElement {
      constructor() {
        super();

        // Check if screen width is below 768px (mobile) - if so, don't initialize
        if (window.innerWidth < 768) {
          console.log('[CollectionSlider] Skipping initialization on mobile device (< 768px)');
          return;
        }

        this.swiper = null;
        this.nextButton = this.querySelector('.collection-slider-button__next');
        this.prevButton = this.querySelector('.collection-slider-button__prev');
        this.sliderEl = this.querySelector('.collection-products-slider__el');
        this.scrollbarEl = this.querySelector('.swiper-scrollbar');
        this.hideScrollbarTimer = null;
  
        this.initSlider = this.initSlider.bind(this);
        this.showScrollbar = this.showScrollbar.bind(this);
        this.scheduleHideScrollbar = this.scheduleHideScrollbar.bind(this);
      }
  
      connectedCallback() {
        console.log('[CollectionSlider] Connected callback called');
        this.initSlider();
      }
  
      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        clearTimeout(this.hideScrollbarTimer);
      }
  
      isTouchDevice() {
        return (
          'ontouchstart' in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0
        );
      }
  
      showScrollbar() {
        if (!this.scrollbarEl) return;
        this.scrollbarEl.classList.add('is-visible');
      }
  
      scheduleHideScrollbar(delay = 900) {
        if (!this.scrollbarEl) return;
        clearTimeout(this.hideScrollbarTimer);
        this.hideScrollbarTimer = setTimeout(() => {
          this.scrollbarEl.classList.remove('is-visible');
        }, delay);
      }
  
      initSlider() {
        if (this.swiper || !this.sliderEl) return;
  
        const isTouch = this.isTouchDevice();
  
        this.swiper = new Swiper(this.sliderEl, {
          loop: false,
          rewind: true,
          slidesPerGroup: 1,
          slidesPerView: 4.5,
          speed: 500,
          spaceBetween: 14,
  
          // ✅ Touch & mouse drag
          allowTouchMove: true,
          simulateTouch: true,          // enables click-drag with mouse
          grabCursor: true,             // nice UX cue
          threshold: 6,                 // avoid accidental drags on tiny moves
  
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 1,
            sticky: true
          },
  
          // Keep wheel off by default to not hijack vertical page scroll.
          // If you want horizontal wheel/trackpad scroll, set enabled: true.
          mousewheel: { 
            enabled: true,
            forceToAxis: true, 
            sensitivity: 1,
            releaseOnEdges: true 
        },
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton
          },
  
          scrollbar: {
            el: this.scrollbarEl || '.swiper-scrollbar',
            draggable: true,
            snapOnRelease: true,
            dragSize: 50
          },
  
          breakpoints: {
            0:    { slidesPerView: 2.5, slidesPerGroup: 1 },
            768:  { slidesPerView: 3.5, spaceBetween: 17, slidesPerGroup: 1 },
            1024: { slidesPerView: 3.5, spaceBetween: 17, slidesPerGroup: 1 }
          },
  
          on: {
            // Reveal/hide scrollbar around interactions
            touchStart: () => { this.showScrollbar(); },
            touchEnd:   () => { this.scheduleHideScrollbar(); },
            sliderMove: () => { this.showScrollbar(); this.scheduleHideScrollbar(1200); },
            setTranslate: () => { this.showScrollbar(); this.scheduleHideScrollbar(800); },
  
            // Scrollbar drag interactions
            scrollbarDragStart: () => { this.showScrollbar(); },
            scrollbarDragEnd:   () => { this.scheduleHideScrollbar(); },
  
            // Navigation buttons also reveal it
          //  navigationNext: () => { this.showScrollbar(); this.scheduleHideScrollbar(); },
           // navigationPrev: () => { this.showScrollbar(); this.scheduleHideScrollbar(); }
          }
        });
  
        // Also reveal scrollbar when clicking nav elements (covers older Swiper)
        this.nextButton?.addEventListener('click', () => { this.showScrollbar(); this.scheduleHideScrollbar(); });
        this.prevButton?.addEventListener('click', () => { this.showScrollbar(); this.scheduleHideScrollbar(); });
  
        // Start hidden
        this.scrollbarEl?.classList.remove('is-visible');
      }
    }
  
    customElements.define('collection-slider', CollectionSlider);
  })();
  